import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppSettings } from './interfaces/app-state-interface.ts';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    settings: {
      EdICD10CodeUploadEnabled: false,
      AmbulatoryICD10CodeUploadEnabled: false,
    },
  },
  reducers: {
    appInitialized(state, _: PayloadAction) {
      return { ...state };
    },
    loadAppSettingsRequested(state, _: PayloadAction) {
      return {
        ...state,
        isLoading: true,
      };
    },
    loadAppSettingsSucceeded(state, action: PayloadAction<{ settings: AppSettings }>) {
      return {
        ...state,
        isLoading: false,
        settings: action.payload.settings,
      };
    },
    loadAppSettingsFailed(state, _: PayloadAction) {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
});

export const {
  appInitialized,
  loadAppSettingsRequested,
  loadAppSettingsSucceeded,
  loadAppSettingsFailed,
} = appSlice.actions;
